import React from "react";
import UserDropdown from "./UserDropdown";
import Indentification from "../../components/elements/Indentification";
import { initialsValue } from "../../helpers";

const AdminHeader = ({ profile }) => {
  const data = {
    image: profile?.image?.url,
    name: profile?.firstName
      ? profile?.firstName + " " + profile?.lastName
      : "Admin",
    email: profile?.email || "admin123@gmail.com",
  };

  return (
    <>
      <header className="relative h-16 z-50 w-full flex py-2 px-3 border-t border-shades-05/25">
        <div className="relative flex items-center gap-1 md:gap-2 w-full">
          <div className="flex-shrink flex-grow mr-auto">
            <div className="flex items-center gap-1 md:gap-2">
              {!data?.image || !!data?.image?.url ? (
                <div className="flex items-center justify-center bg-catskill-white text-chestnut-rose rounded-full w-4 md:w-5 h-4 md:h-5">
                  <i className="fa-regular fa-user" />
                </div>
              ) : (
                <Indentification initial={initialsValue(data?.name)} />
              )}
              <div
                className={`text-xs font-medium text-gable-green whitespace-nowrap truncate`}
              >
                {data?.name}
              </div>
            </div>
          </div>
          <div className="flex-shrink-0 flex items-center gap-1 ml-auto">
            <UserDropdown data={data} xPlacement={"topRight"} />
          </div>
        </div>
      </header>
    </>
  );
};

export default AdminHeader;
